// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { CreateShareConfigDTO, ProcedureReportProps } from '../../../../Types/LogT';
import { getReportExecutionState } from './reportExecutionState';

const CreateShareReport: FC<ProcedureReportProps> = ({ report, config }) => {
  const cfg = config as CreateShareConfigDTO;
  const { name } = cfg;
  const executionState = getReportExecutionState(report?.executionStatus);

  return (
    <Text>
      {executionState === 'SKIPPED' ? 'Erstellung der Freigabe' : 'Freigabe'}{' '}
      <Text span weight="bolder">
        {name}
      </Text>{' '}
      {executionState === 'COMPLETED' && 'wurde erstellt.'}
      {executionState === 'PLANNED' && 'wird erstellt.'}
      {executionState === 'SKIPPED' && 'wurde übersprungen.'}
      {executionState === 'NOT_EXECUTED' && 'wurde nicht erstellt.'}
    </Text>
  );
};

export default CreateShareReport;
